import React from "react";
import { MenuItem, Select, TextField } from "@material-ui/core";
import PropTypes from "prop-types";

import { useStyles } from "./FilterDropDown.styles";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { useTranslation } from "react-i18next";

const ValueField = ({ setRow, row, rule, index, menuProps }) => {
  const classes = useStyles(["common"]);
  const { t } = useTranslation();
  const type = rule?.column?.valueType;

  switch (type) {
    case "date":
      return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            className={classes.datePicker}
            disableToolbar
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            id="date-picker-inline"
            disable
            inputProps={{ disabled: true }}
            value={rule?.value || null}
            emptyLabel={"DD/MM/YYYY"}
            onChange={(date) => {
              const currentRows = row;
              currentRows[index] = {
                column: currentRows[index].column,
                value: date,
              };
              setRow([...currentRows]);
            }}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
          />
        </MuiPickersUtilsProvider>
      );

    case "select":
      return (
        <Select
          labelId={"filterValueLabel" + index}
          id={"filterValueSelectPlaceholderLabel" + index}
          value={rule.value}
          MenuProps={menuProps}
          onChange={(e) => {
            const currentRows = row;
            currentRows[index] = {
              column: currentRows[index].column,
              value: e.target.value,
            };
            setRow([...currentRows]);
          }}
          displayEmpty
          className={classes.selectEmpty}
        >
          <MenuItem value="" className={classes.placeholder}>
            {t("common:filter.selectPlaceholder", {
              val: rule?.column.columnLabel,
            })}
          </MenuItem>
          {rule?.column?.selectableContents?.map((data, i) => {
            return (
              <MenuItem key={i} value={data}>
                {data.value}
              </MenuItem>
            );
          })}
        </Select>
      );

    default:
      return (
        <TextField
          value={rule.value}
          placeholder={t("common:filter.inputPlaceholder", {
            val: rule?.column.columnLabel,
          })}
          onChange={(e) => {
            const currentRows = row;
            currentRows[index] = {
              column: currentRows[index].column,
              value: e.target.value,
            };
            setRow([...currentRows]);
          }}
        />
      );
  }
};

ValueField.propTypes = {
  index: PropTypes.number,
  setRow: PropTypes.func,
  menuProps: PropTypes.object,
  row: PropTypes.array,
  rule: PropTypes.object,
};

export { ValueField };
